module.exports = __webpack_public_path__ + "static/media/wrecked-ship.35b72528.jpg";